var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraAnimation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 3-4 2v-.5a1.538 1.538 0 0 0 -1.5-1.5h-9a1.538 1.538 0 0 0 -1.5 1.5v7a1.538 1.538 0 0 0 1.5 1.5h9a1.538 1.538 0 0 0 1.5-1.5v-.5l4 2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraAnimation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera-animation.4cdf9a45cf86f3d0822213008acc7188.svg";